import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { PageHeaderComponent } from '@shared/page/page-header/page-header.component';

import { PageComponent } from './page.component';

@NgModule({
  declarations: [PageComponent, PageHeaderComponent],
  imports: [FormsModule, CommonModule],
  exports: [PageComponent, PageHeaderComponent]
})
export class PageModule {}
